export const COLORS_WHITE = '#fff';
export const COLORS_HOME_LIGHT_BLUE = '#f1faff';
export const COLORS_HOME_MEDIUM_BLUE = '#99cbe4';

export const SCROLL_TOP_OFFSET_DEFAULT = -50;
